/** Minute width used to align access expiry presets and time-picker options. */
export const ACCESS_TIME_SLOT_MINUTES = 15;
export const ACCESS_TIME_SLOTS_PER_DAY = (24 * 60) / ACCESS_TIME_SLOT_MINUTES;
export const LAST_ACCESS_TIME_SLOT = ACCESS_TIME_SLOTS_PER_DAY - 1;
